'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const FolderIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="FolderIcon">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2436_6631)">
          <path
            d="M20.8993 9.44223C20.925 9.31634 20.9223 9.18631 20.8915 9.06158C20.8607 8.93684 20.8025 8.82053 20.7211 8.7211C20.6397 8.62166 20.5372 8.5416 20.4211 8.48671C20.3049 8.43182 20.178 8.40349 20.0495 8.40377H9.78687C9.58723 8.40401 9.39364 8.33521 9.23892 8.20904C9.0842 8.08287 8.97786 7.90708 8.93793 7.71146L8.69736 6.49993C8.65743 6.30431 8.55109 6.12852 8.39637 6.00235C8.24165 5.87617 8.04806 5.80738 7.84841 5.80762H2.25803C2.12962 5.80746 2.00278 5.83589 1.88671 5.89083C1.77065 5.94578 1.66827 6.02586 1.58699 6.12528C1.50572 6.2247 1.44759 6.34096 1.41681 6.46563C1.38604 6.5903 1.3834 6.72026 1.40909 6.84608L3.65909 18.0961C3.69901 18.2917 3.80535 18.4675 3.96007 18.5937C4.11479 18.7198 4.30838 18.7886 4.50803 18.7884H18.3196C18.5192 18.7886 18.7128 18.7198 18.8675 18.5937C19.0222 18.4675 19.1286 18.2917 19.1685 18.0961C19.525 16.3082 20.477 11.5512 20.8993 9.44223Z"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeWidth="0.865385"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.12305 4.07693C3.12305 3.84742 3.21422 3.6273 3.37651 3.46501C3.5388 3.30272 3.75892 3.21155 3.98843 3.21155H18.7C18.9295 3.21155 19.1496 3.30272 19.3119 3.46501C19.4742 3.6273 19.5654 3.84742 19.5654 4.07693V6.67309"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeWidth="0.865385"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2436_6631">
            <rect width="20.7692" height="20.7692" fill="white" transform="translate(0.769531 0.615356)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

FolderIcon.propTypes = {
  sx: PropTypes.object
}
